import { Theme } from 'app/components/v2/theme';

export const getOutlineColor = (theme: Theme) => {
  return theme.semanticColors.border_focus;
};
